import { NavLink, Outlet, useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@/store/auth'
import { Badge } from '@diwata/ironvale'

type FamiliarTier = 'sovereign' | 'adept' | 'guild'

function tierVariant(tier: string): FamiliarTier {
  if (tier === 'sovereign' || tier === 'adept' || tier === 'guild') return tier
  return 'guild'
}

function statusVariant(status: string) {
  if (status === 'active') return 'success' as const
  if (status === 'suspended') return 'error' as const
  return 'neutral' as const
}

export function FamiliarHub() {
  const { id } = useParams<{ id: string }>()
  const api = useAuth((s) => s.api)()
  const { data: familiar } = useQuery({
    queryKey: ['familiar', id],
    queryFn: () => api.getFamiliar(id!),
    enabled: !!id,
  })

  const base = `/familiar/${id}`

  return (
    <div>
      <div className="cp-page-header">
        <div>
          <div className="cp-page-title">{familiar?.name ?? '…'}</div>
          {familiar && (
            <div className="cp-familiar-meta" style={{ marginTop: 4 }}>
              <Badge variant={tierVariant(familiar.tier)}>{familiar.tier}</Badge>
              <Badge variant={statusVariant(familiar.status)}>{familiar.status}</Badge>
            </div>
          )}
        </div>
      </div>

      <nav className="cp-subnav">
        {[
          { to: base,                    label: 'Overview', end: true },
          { to: `${base}/chat`,          label: 'Chat' },
          { to: `${base}/constellation`, label: 'Constellation' },
          { to: `${base}/memory`,        label: 'Memory' },
          { to: `${base}/adepts`,        label: 'Adepts' },
          { to: `${base}/channels`,      label: 'Channels' },
          { to: `${base}/covenant`,      label: 'Covenant' },
        ].map(({ to, label, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) => `cp-subnav-link${isActive ? ' active' : ''}`}
          >
            {label}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  )
}
